import { render, staticRenderFns } from "./tag-search-form.vue?vue&type=template&id=097a87ae&"
import script from "./tag-search-form.vue?vue&type=script&lang=js&"
export * from "./tag-search-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports